/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {TransferResponseList} from '../../core/_models'
import {useNavigate} from 'react-router-dom'

type Props = {
  transfer: TransferResponseList
}

const get_badge_class = (text) => {
  let badgeClass = ''
  switch (text) {
    case 'Aprovado':
      badgeClass = 'success'
      break
    case 'Completado':
      badgeClass = 'info'
      break
    case 'Pendente':
      badgeClass = 'warning'
      break
    default:
      badgeClass = 'danger'
      break
  }
  return badgeClass
}

export const StatusCell: FC<Props> = ({transfer}) => {
  return (
    <div className='d-flex align-items-center'>
      <div className='d-flex flex-column'>
        <span className={`badge badge-${get_badge_class(transfer.transferStatus)}`}>
          {transfer.transferStatus}
        </span>
      </div>
    </div>
  )
}
